import React, { Component } from "react";
import config from "lib/fr-config";
import ContainedCommonButtonView from "presentational/common/ContainedCommonButtonView";
import TextButtonView from "presentational/common/TextButtonView";
import DropdownButtonView from "presentational/common/DropdownButtonView";
import CommonTextField from "presentational/common/CommonTextField";
import DateText from "presentational/common/multinational/DateText";
import TXT from "presentational/common/multinational/TXT";
import FloatingBoxView from "presentational/account/FloatingBoxView";
import CommonModalView from "presentational/common/modals/CommonModalView";
import CommonAuthButtonView from "presentational/account/CommonAuthButtonView";
import TermsText from "presentational/termsAndPrivacy/TermsText";
import PrivacyText from "presentational/termsAndPrivacy/PrivacyText";
import { isValidInput } from "lib/textFilter";
import { withStore } from "store/storeHandler";
import { getFilteredInput } from "lib/textFilter";
import { withStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";

const fontCss = config.css.fontThickness;

const LIST_OF_LOCATION = config.listOfLocsInService;

const CustomListItem = withStyles({
  root: { paddingLeft: 0, paddingRight: 0 }
})(ListItem);
const CustomCheckbox = withStyles({
  root: { marginLeft: -12 }
})(Checkbox);
const CustomListItemText = withStyles({
  primary: { fontSize: 14 }
})(ListItemText);
const TitleTypography = withStyles({
  root: { fontSize: 30, fontWeight: fontCss.bold, lineHeight: 1.5 }
})(Typography);
const WarningTypography = withStyles({
  root: { fontSize: 14 }
})(Typography);
const TermsTypography = withStyles({
  root: { fontSize: 12 }
})(Typography);

const css = {
  root: {},
  upperArea: {
    marginTop: 40,
    marginBottom: 50
  },
  input: {
    paddingTop: 6,
    paddingBottom: 6
  },
  buttonInput: {
    display: "flex",
    justifyContent: "center",
    paddingTop: 22,
    paddingBottom: 0
  },
  signUpNotice: {
    paddingTop: 30
  },
  codeInput: {
    paddingTop: 30
  },
  newPwInput: {
    paddingTop: 30
  },
  forgotPwButton: {
    display: "flex",
    justifyContent: "center"
  },
  lowerArea: {
    marginTop: 50
  },
  button: {
    paddingTop: 2
  },
  toggleButton: {
    paddingTop: 6,
    display: "flex",
    justifyContent: "center"
  }
};

class CommonAccountPanelView extends Component {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    textElement: PropTypes.array,
    onInputValueChange: PropTypes.func,

    firstBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    firstButtonDisabled: PropTypes.bool,
    onFirstBtnClick: PropTypes.func,

    forgetPwBtnText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onForgetPwBtnClick: PropTypes.func,

    modeToggleBtnText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    onModeToggleBtnClick: PropTypes.func,
    emailForHelperTxt: PropTypes.string,

    onLoginViaEmailBtnClick: PropTypes.func,
    onLoginViaGoogleBtnClick: PropTypes.func
  };

  static defaultProps = {
    textElement: [],
    onInputValueChange: () => {},

    firstBtnText: null,
    firstButtonDisabled: false,
    onFirstBtnClick: () => {},

    modeToggleBtnText: null,
    onModeToggleBtnClick: () => {},

    emailForHelperTxt: null,

    onLoginViaEmailBtnClick: () => {},
    onLoginViaGoogleBtnClick: () => {}
  };

  state = {
    selectedGender: null,
    selectedLocation: null,

    email: "",
    passwordForAuth: "",
    passwordToCreate: "",
    confirmPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    signUpAgreement: false,
    username: "",
    birthday: "",
    confirmationCode: "",

    termsModalOpen: false,
    privacyModalOpen: false
  };

  setInitialLocation() {
    const { viewerLocation } = this.props;
    if (LIST_OF_LOCATION.indexOf(viewerLocation) === -1) {
      return null;
    }
    this.handleDropdownChange("selectedLocation", viewerLocation);
  }

  getHelperTextForUsername(username) {
    const filteredUsername = getFilteredInput("username", username);
    const guideText = <TXT name="msg_helperUsername" />;
    const helperText = isValidInput("username", filteredUsername)
      ? filteredUsername
      : guideText;
    return helperText;
  }

  getHelperTextForBirthday(birthday) {
    const filteredText = getFilteredInput("birthday", birthday);

    if (!filteredText || filteredText.length !== 8) {
      return <TXT name="msg_helperPrivateInfo" />;
    }

    const year = Number(filteredText.substring(0, 4));
    const month = Number(filteredText.substring(4, 6));
    const day = Number(filteredText.substring(6));

    return (
      <DateText
        inputType={"inputYM"}
        outputType={"outputYMD"}
        year={year}
        month={month}
        day={day}
      />
    );
  }

  getLocationIndexList() {
    const locationList = config.listOfLocsInService;
    return locationList.map(val => ({
      value: val,
      text: <TXT textType="location" name={val} />
    }));
  }

  getInputUnit(type, index) {
    const {
      viewerLocation,
      onLoginViaEmailBtnClick,
      onLoginViaGoogleBtnClick
    } = this.props;
    const {
      selectedGender,
      selectedLocation,
      email,
      passwordForAuth,
      passwordToCreate,
      confirmPassword,
      newPassword,
      confirmNewPassword,
      signUpAgreement,
      username,
      birthday,
      confirmationCode,
      termsModalOpen,
      privacyModalOpen
    } = this.state;
    const textIndex = `input${index}`;

    switch (type) {
      case "email":
        return (
          <div key={type} style={css.input}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_email" />}
              type="email"
              margin="none"
              value={email}
              onChange={this.handleChange("email")}
            />
          </div>
        );
      case "passwordForAuth":
        return (
          <div key={type} style={css.input}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_password" />}
              type="password"
              margin="none"
              value={passwordForAuth}
              onChange={this.handleChange("passwordForAuth")}
            />
          </div>
        );
      case "passwordToCreate":
        return (
          <div key={type} style={css.input}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_password" />}
              type="password"
              margin="none"
              value={passwordToCreate}
              onChange={this.handleChange("passwordToCreate")}
              helperText={
                !isValidInput("password", passwordToCreate.trim()) ? (
                  <TXT name="msg_pwFormatGuide" />
                ) : null
              }
            />
          </div>
        );
      case "confirmPassword":
        return (
          <div key={type} style={css.input}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_confirmPassword" />}
              type="password"
              margin="none"
              value={confirmPassword}
              onChange={this.handleChange("confirmPassword")}
            />
          </div>
        );
      case "newPassword":
        return (
          <div key={type} style={{ ...css.input, ...css.newPwInput }}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_newPassword" />}
              type="password"
              margin="none"
              value={newPassword}
              onChange={this.handleChange("newPassword")}
              helperText={
                !isValidInput("password", newPassword.trim()) ? (
                  <TXT name="msg_pwFormatGuide" />
                ) : null
              }
            />
          </div>
        );
      case "confirmNewPassword":
        return (
          <div key={type} style={css.input}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_confirmNewPassword" />}
              type="password"
              margin="none"
              value={confirmNewPassword}
              onChange={this.handleChange("confirmNewPassword")}
            />
          </div>
        );
      case "signUpAgreement":
        return (
          <div key={type} style={css.input}>
            <List>
              <CustomListItem>
                <CustomCheckbox
                  checked={signUpAgreement}
                  onChange={this.handleCheckboxChange}
                  value={"signUpAgreement"}
                  disableRipple
                />
                <CustomListItemText
                  primary={
                    <TXT
                      name="msg_agreeTermsAndPolicyChkbox"
                      btnFuncObj={{
                        terms: () => this.setState({ termsModalOpen: true }),
                        privacy: () => this.setState({ privacyModalOpen: true })
                      }}
                    />
                  }
                />
              </CustomListItem>
            </List>
            <CommonModalView
              open={termsModalOpen}
              onClose={this.handleModalClose}
              contentComponent={
                <TermsText language={viewerLocation === "KR" ? "ko" : "en"} />
              }
              firstButtonText={<TXT name="btnModal_close" />}
              firstButtonFunc={this.handleModalClose}
            />
            <CommonModalView
              open={privacyModalOpen}
              onClose={this.handleModalClose}
              contentComponent={
                <PrivacyText language={viewerLocation === "KR" ? "ko" : "en"} />
              }
              firstButtonText={<TXT name="btnModal_close" />}
              firstButtonFunc={this.handleModalClose}
            />
          </div>
        );
      case "username":
        return (
          <div key={type} style={css.input}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_username" />}
              margin="none"
              value={username}
              helperText={this.getHelperTextForUsername(username)}
              onChange={this.handleChange("username")}
            />
          </div>
        );
      case "birthday":
        return (
          <div key={type} style={css.input}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_birthday" />}
              margin="none"
              type="date"
              shrinkLabel
              value={birthday}
              helperText={this.getHelperTextForBirthday(birthday)}
              onChange={this.handleChange("birthday")}
            />
          </div>
        );
      case "gender":
        return (
          <div
            key={type}
            ref={ref => {
              this[textIndex] = ref;
            }}
            style={{ ...css.input, ...css.buttonInput }}
          >
            <TextButtonView
              disableLeftMargin
              design={selectedGender === "male" ? "select" : "unselect"}
              onClick={this.handleGenderChange("male")}
            >
              <TXT name="btnSelect_maleSignUp" />
            </TextButtonView>
            <TextButtonView
              design={selectedGender === "female" ? "select" : "unselect"}
              onClick={this.handleGenderChange("female")}
            >
              <TXT name="btnSelect_femaleSignUp" />
            </TextButtonView>
          </div>
        );
      case "location":
        return (
          <div
            key={type}
            ref={ref => {
              this[textIndex] = ref;
            }}
            style={{ ...css.input, ...css.buttonInput }}
          >
            <DropdownButtonView
              disableLeftMargin
              dropdownName={"location"}
              menuList={this.getLocationIndexList()}
              selectedItem={selectedLocation}
              onSelect={this.handleDropdownChange}
              prefixText={<TXT name="btnSelect_location" />}
              initialText={<TXT name="btnSelect_location" />}
            />
          </div>
        );
      case "confirmationCode":
        const { emailForHelperTxt, AppErrorActions } = this.props;
        if (!emailForHelperTxt) {
          AppErrorActions.setSafeAppError(
            Error(`[CommonAccountPanelView] null email`)
          );
        }
        return (
          <div key={type} style={{ ...css.input, ...css.codeInput }}>
            <CommonTextField
              inputRef={ref => (this[textIndex] = ref)}
              onKeyDown={this.handleKeyPress(index)}
              label={<TXT name="wordPlaceholder_verificationCode" />}
              margin="none"
              value={confirmationCode}
              onChange={this.handleChange("confirmationCode")}
              helperText={
                <TXT
                  name="msg_helperVerificationCode"
                  input={{ email: emailForHelperTxt }}
                />
              }
            />
          </div>
        );
      case "signUpNotice":
        return (
          <div
            key={type}
            ref={ref => {
              this[textIndex] = ref;
            }}
            style={{ ...css.input, ...css.signUpNotice }}
          >
            <WarningTypography>
              <span>- </span>
              <TXT name="msg_warningSignUp1st" />
            </WarningTypography>
            <WarningTypography>
              <span>- </span>
              <TXT name="msg_warningSignUp2nd" />
            </WarningTypography>
          </div>
        );
      case "authLogin":
        return (
          <div key={type}>
            <div style={{ paddingTop: 42 }}>
              <CommonAuthButtonView
                btnType={"email"}
                onClick={onLoginViaEmailBtnClick}
              />
            </div>
            <div style={{ paddingTop: 16 }}>
              <CommonAuthButtonView
                btnType={"google"}
                onClick={onLoginViaGoogleBtnClick}
              />
            </div>
            <div style={{ paddingTop: 16 }}>
              <TermsTypography>
                <TXT
                  name="msg_agreeTermsAndPolicyNotice"
                  btnFuncObj={{
                    terms: () => this.setState({ termsModalOpen: true }),
                    privacy: () => this.setState({ privacyModalOpen: true })
                  }}
                />
              </TermsTypography>
            </div>
            <CommonModalView
              open={termsModalOpen}
              onClose={this.handleModalClose}
              contentComponent={
                <TermsText language={viewerLocation === "KR" ? "ko" : "en"} />
              }
              firstButtonText={<TXT name="btnModal_close" />}
              firstButtonFunc={this.handleModalClose}
            />
            <CommonModalView
              open={privacyModalOpen}
              onClose={this.handleModalClose}
              contentComponent={
                <PrivacyText language={viewerLocation === "KR" ? "ko" : "en"} />
              }
              firstButtonText={<TXT name="btnModal_close" />}
              firstButtonFunc={this.handleModalClose}
            />
          </div>
        );
      default:
        break;
    }
  }

  getInputElement(orderArray) {
    return orderArray.map((type, index) => this.getInputUnit(type, index));
  }

  handleKeyPress = index => event => {
    const { onFirstBtnClick } = this.props;
    const nextTextIndex = `input${index + 1}`;
    if (event.key === "Enter") {
      if (!!this[nextTextIndex]) {
        this[nextTextIndex].focus();
      } else {
        onFirstBtnClick();
      }
      event.preventDefault();
    }
  };

  handleGenderChange = type => () => {
    const { onInputValueChange } = this.props;
    this.setState({ selectedGender: type });
    onInputValueChange("gender", type);
  };

  handleDropdownChange = (key, value) => {
    const { textElement, onInputValueChange } = this.props;

    if (textElement.indexOf("location") === -1) {
      return null;
    }

    this.setState({ selectedLocation: value });
    onInputValueChange("location", value);
  };

  handleChange = type => e => {
    const { onInputValueChange } = this.props;

    const value = e.target.value;
    let filteredValue;
    switch (type) {
      case "username":
        filteredValue = getFilteredInput(type, value);
        if (!isValidInput("username", filteredValue)) {
          filteredValue = null;
        }
        break;
      case "birthday":
        filteredValue = getFilteredInput(type, value);
        break;
      default:
        filteredValue = value;
        break;
    }

    this.setState({ [type]: value });
    onInputValueChange(type, filteredValue);
  };

  handleCheckboxChange = e => {
    const { onInputValueChange } = this.props;
    const { value, checked } = e.target;
    this.setState({ [value]: checked });
    onInputValueChange(value, checked);
  };

  handleModalClose = () => {
    this.setState({ termsModalOpen: false, privacyModalOpen: false });
  };

  render() {
    const {
      title,
      textElement,
      firstBtnText,
      firstButtonDisabled,
      onFirstBtnClick,
      forgetPwBtnText,
      onForgetPwBtnClick,
      modeToggleBtnText,
      onModeToggleBtnClick
    } = this.props;

    return (
      <FloatingBoxView>
        <div style={css.root}>
          <TitleTypography variant="h2" gutterBottom>
            {title}
          </TitleTypography>
          <div style={css.upperArea}>
            {this.getInputElement(textElement)}
            {forgetPwBtnText && (
              <div style={css.forgotPwButton}>
                <TextButtonView
                  forAccountPanel
                  design={"unselect"}
                  onClick={onForgetPwBtnClick}
                >
                  {forgetPwBtnText}
                </TextButtonView>
              </div>
            )}
          </div>
          <div style={css.lowerArea}>
            {firstBtnText && (
              <div style={css.button}>
                <ContainedCommonButtonView
                  forAccountPanel
                  fullWidth
                  onClick={onFirstBtnClick}
                  disabled={firstButtonDisabled}
                >
                  {firstBtnText}
                </ContainedCommonButtonView>
              </div>
            )}
            {modeToggleBtnText && (
              <div style={{ ...css.button, ...css.toggleButton }}>
                <TextButtonView
                  forAccountPanel
                  design={"unselect"}
                  onClick={onModeToggleBtnClick}
                >
                  {modeToggleBtnText}
                </TextButtonView>
              </div>
            )}
          </div>
        </div>
      </FloatingBoxView>
    );
  }

  componentDidMount() {
    this.setInitialLocation();
  }
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  },
  dispatchMap: ["appError"]
})(CommonAccountPanelView);
